/* eslint-disable max-len */
import React from 'react';

const WaSunny = () => (
    <svg
        width="5rem"
        height="5rem"
        viewBox="-33 0 300 320"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="xMinYMid meet"
        style={{ display: 'block' }}
    >
        <path d="M224.202 186.864C225.899 246.742 178.207 312.36 117.13 314.053C56.0523 315.745 4.71877 252.87 3.02189 192.992C0.693791 110.841 50.3159 88.1366 111.327 109.299C170.288 90.145 217.888 99.4907 224.202 186.864Z" fill="#FF9334" />
        <ellipse cx="5.49981" cy="9.93187" rx="5.49981" ry="9.93187" transform="matrix(0.999615 -0.0276963 0.0283276 0.9996 100.097 169.507)" fill="#411A50" />
        <ellipse cx="5.49981" cy="9.93187" rx="5.49981" ry="9.93187" transform="matrix(0.999615 -0.0276963 0.0283276 0.9996 181.766 167.511)" fill="#411A50" />
        <path fillRule="evenodd" clipRule="evenodd" d="M173.461 213.494L132.336 216.913C132.336 216.913 138.329 246.844 158.754 244.464C158.754 244.464 177.029 242.998 173.461 213.494Z" fill="white" stroke="#411A50" strokeWidth="3.21041" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M59.7975 2.61839C133.963 19.485 134.535 57.4916 125.551 74.3867L120.545 80.855C71.703 67.8449 59.6959 23.2764 59.7975 2.61839Z" fill="#2EBF60" />
        <path d="M143.032 58.7863C143.032 58.7863 118.368 72.592 111.131 113.596" stroke="#411A50" strokeWidth="3.21041" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M121.844 81.1113C121.844 81.1113 117.179 45.7384 82.6314 29.7914" stroke="#411A50" strokeWidth="3.21041" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M143.032 58.7863C143.032 58.7863 118.368 72.592 111.131 113.596" stroke="#411A50" strokeWidth="3.21041" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export default WaSunny;
